import * as React from 'react';

export function ConsentReturn({ failed, language }: { failed: boolean; language: string }) {
  return (
    <p style={{ padding: 24 }}>
      {failed
        ? language.startsWith('fr')
          ? "L'autorisation n'a pas abouti. Réessayez depuis elba, dans Phishing › Paramètres, avec un compte administrateur Microsoft."
          : "Authorisation didn't go through. Try again from elba, in Phishing › Settings, with a Microsoft administrator account."
        : language.startsWith('fr')
          ? "C'est fait : vos employés peuvent signaler des emails depuis Outlook. Vous pouvez fermer cette page."
          : 'Done. Your employees can now report emails from Outlook. You can close this page.'}
    </p>
  );
}
